/* eslint-disable import/no-unresolved */
import 'swiper/css';
import 'swiper/css/free-mode';

import cx from 'clsx';
import { Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { trackEvent } from '@kcd/event-tracker';

import { ShoebillImage } from '~/components/Image';
import type { OAISchema } from '~/types/openapi';

type Props = {
  products: OAISchema['MarketSelectProductResponseV2'][];
  selectedProduct: OAISchema['MarketSelectProductResponseV2'];
  setSelectedProduct: (
    product: OAISchema['MarketSelectProductResponseV2'],
  ) => void;
};

const RecentlyViewedProducts = ({
  products,
  selectedProduct,
  setSelectedProduct,
}: Props) => {
  const onClickProduct = (
    product: OAISchema['MarketSelectProductResponseV2'],
  ) => {
    trackEvent('clicked button in 마켓/홈', {
      placementName: '최근본상품',
    });
    setSelectedProduct(product);
  };

  return (
    <Swiper modules={[Lazy]} slidesPerView="auto" lazy className="mb-12">
      {products.slice(0, 10).map((product) => (
        <SwiperSlide
          key={product.offerId}
          className="ml-8 !w-[70px] first-of-type:ml-20 last-of-type:mr-20"
        >
          <div
            className={cx(
              'rounded-12 overflow-hidden bg-gray-000',
              selectedProduct.offerId === product.offerId
                ? 'border-2 border-primary-regular'
                : 'border border-gray-200',
            )}
            role="presentation"
            onClick={() => onClickProduct(product)}
          >
            <ShoebillImage
              src={product.mainImages![0]}
              width={100}
              height={100}
              layout="responsive"
              objectFit="contain"
            />
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default RecentlyViewedProducts;
